export default __webpack_public_path__ + "static/media/radijatorsol.a7a7eecd.png";